import { defa, T }           from 'defa-object';
import BaseController        from 'scripts/defa/application/controller-base-controller';
import { ObjectHandler }     from 'scripts/defa/application/radio-channel';
import BaseRouter            from 'scripts/defa/application/router-base-router';
import LayoutHandler         from 'scripts/defa/application/service-layout-handler';
import NavHandler            from 'scripts/defa/application/service-nav-handler';
import PageVisibilityHandler from 'scripts/defa/application/service-page-visibility-handler';
import UserHandler           from 'scripts/defa/application/service-user-handler';
import CustomerController    from 'scripts/defa/customers/controller-customer-controller';
import CustomerRouter        from 'scripts/defa/customers/router-customer-router';


/**
 * defa.application.Link
 * Main object of the DEFA Link application.
 * @version 1.2.0
 */

const channelUser   = Bb.Radio.channel( 'user' ),
	  channelLayout = Bb.Radio.channel( 'layout' ),
	  channelNav    = Bb.Radio.channel('nav' );

const Link = Mn.Application.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * @constructor
	 */
	initialize: function () { /* eslint-disable no-unused-vars */
		
		// init all services
		// noinspection JSUnusedLocalSymbols -- these are needed for their side effects
		let userHandler           = new UserHandler(),
			layoutHandler         = new LayoutHandler(),
			pageVisibilityHandler = new PageVisibilityHandler(),
			navHandler            = new NavHandler(),
			objectHandler         = ObjectHandler;
		
		// don't start app until user:first event triggers. (the first active user)
		this.listenToOnce( channelUser, 'user:first', this.start );
		
		// detect environment, and initiate calling on the first unit to initiate.
		if ( defa.vars.android ) {
			window.android.scriptLoaded( 'true' );
		} else if ( defa.vars.webkit ) {
			window.webkit.messageHandlers.scriptLoaded.postMessage( 'true' );
		} else {
			channelUser.trigger( 'user:init' );
		}
	},
	
	/**
	 * Triggers before the app starts.
	 * @void
	 */
	onBeforeStart: function () {
		
		// set behaviors lookup
		Mn.Behaviors.behaviorsLookup = function () {
			return defa.behaviors;
		};
		
		// attach i18n to the template renderer
		Mn.View.setRenderer( ( template, data ) => {
			return Mn.Renderer.render( template, Object.assign( data, { i18n: T } ) );
		} );
		
		// Paulo Vieira event leakage solution: https://github.com/marionettejs/backbone.marionette/issues/2967
		Mn.getClosestCid = function ( el ) {
			return $( el ).closest( '[data-cid*="view"]' ).attr( 'data-cid' );
		};
		
		// set root view
		this.root = channelLayout.request( 'root' );
	},
	
	/**
	 * Triggers when the application starts.
	 * @void
	 */
	onStart: function () {
		
		this._setupControllers();
		
		// start the history / app is now running
		Bb.history.start( {
			pushState: true,
			root     : defa.vars.base,
		} );
		
		// set init true in the view
		channelLayout.trigger( 'init' );
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Sets up all the controller and router pairs for the application.
	 * @void
	 */
	_setupControllers: function () {
		
		let baseController    = new BaseController();
		baseController.router = new BaseRouter( {
			controller: baseController,
		} );
		
		let customerController    = new CustomerController();
		customerController.router = new CustomerRouter( {
			controller: customerController,
		} );
		
		let invitationController    = new defa.controllers.InvitationController();
		invitationController.router = new defa.routers.InvitationRouter( {
			controller: invitationController,
		} );
		let legacyController    = new defa.controllers.LegacyController();
		legacyController.router = new defa.routers.LegacyRouter( {
			controller: legacyController,
		} );
		
		let recipientController    = new  defa.controllers.RecipientController();
		recipientController.router = new  defa.routers.RecipientRouter( {
			controller: recipientController,
		} );
		
		let roleApplicationController = new  defa.controllers.RoleApplicationController();
		roleApplicationController.router = new  defa.routers.RoleApplicationRouter( {
			controller: roleApplicationController,
		} );
		
		let subscriptionController    = new defa.controllers.SubscriptionController();
		subscriptionController.router = new defa.routers.SubscriptionRouter( {
			controller: subscriptionController,
		} );
		
		let termsAndConditionController = new defa.controllers.TermsAndConditionsController();
		termsAndConditionController.router = new defa.routers.TermsAndConditionsRouter( {
			controller: termsAndConditionController,
		});

		let unitController    = new defa.controllers.UnitController();
		unitController.router = new defa.routers.UnitRouter( {
			controller: unitController,
		} );
		
		
		let userController    = new defa.controllers.UserController();
		userController.router = new defa.routers.UserRouter( {
			controller: userController,
		} );
		
		if ( channelUser.request( 'model' ).hasRoles( [ 'TECHNICAL_SUPPORT', ] ) ) {
			let supportController = new defa.controllers.SupportController();
			
			supportController.router = new defa.routers.SupportRouter( {
				controller: supportController,
			} );
			
			supportController.attachSupportContainer();
			
			// !TODO: Attaching the support container should be done by the layoutHandler.
			// !TODO: The support button code is in support/view-support-container.js - it too should be in the
			// layoutHandler.
			
		}
		
	},
	
} );

export default Link;
